import * as React from "react";
import { IRepertoireField } from "../../../types/IRepertoireField";

export interface IYesNoPromptViewModalProps {  
    yesCallback: () => void;
    noCallback: () => void;
}

export interface IYesNoPromptViewProps {
    fields: IRepertoireField[];
    props: IYesNoPromptViewModalProps;
}

const YesNoPromptView: React.SFC<IYesNoPromptViewProps> = ({ fields, props }) => {
    const { yesCallback, noCallback } = props;
    const yesButtonText: string = fields.find(f=>f.name==="yesButton").data;
    const noButtonText: string = fields.find(f=>f.name==="noButton").data;
    return (
        <div className="yesNoPromptView">
            <div className="row">
                <div className="col-xs-6">
                    <button className="button btn-defaultSecondary btn-sm pull-left" onClick={noCallback}>
                        {noButtonText}
                    </button>
                </div>

                <div className="col-xs-6">
                    <button className="button btn-defaultPrimary btn-sm pull-right" onClick={yesCallback}>
                        {yesButtonText}
                    </button>
                </div>
            </div>
        </div>
  );
};

export default YesNoPromptView;